import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const MessagePartiallySeenIcon = (props: IconProps) => (
  <Icon w="17px" h="16px" viewBox="0 0 17 16" {...props}>
    <g clipPath="url(#clip0_3392_7700)">
      <mask
        id="mask0_3392_7700"
        maskUnits="userSpaceOnUse"
        x="-1"
        y="1"
        width="18"
        height="11"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6667 1.33334H-0.666626V8.00001H4.01499C4.1834 9.86884 5.75403 11.3333 7.66671 11.3333C9.57939 11.3333 11.15 9.86884 11.3184 8.00001H16.6667V1.33334Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_3392_7700)">
        <path
          d="M7.99996 4.33333C10.5266 4.33333 12.78 5.75333 13.88 8C12.78 10.2467 10.5266 11.6667 7.99996 11.6667C5.47329 11.6667 3.21996 10.2467 2.11996 8C3.21996 5.75333 5.47329 4.33333 7.99996 4.33333ZM7.99996 3C4.66663 3 1.81996 5.07333 0.666626 8C1.81996 10.9267 4.66663 13 7.99996 13C11.3333 13 14.18 10.9267 15.3333 8C14.18 5.07333 11.3333 3 7.99996 3ZM7.99996 6.33333C8.91996 6.33333 9.66663 7.08 9.66663 8C9.66663 8.92 8.91996 9.66667 7.99996 9.66667C7.07996 9.66667 6.33329 8.92 6.33329 8C6.33329 7.08 7.07996 6.33333 7.99996 6.33333ZM7.99996 5C6.34663 5 4.99996 6.34667 4.99996 8C4.99996 9.65333 6.34663 11 7.99996 11C9.65329 11 11 9.65333 11 8C11 6.34667 9.65329 5 7.99996 5Z"
          fill="#5B5B5B"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3392_7700">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(MessagePartiallySeenIcon);
